import {
  INITIALISE_ATTACHMENTS,
  UPLOAD_ATTACHMENT_REQUEST,
  UPLOAD_ATTACHMENT_SUCCESS,
  UPLOAD_ATTACHMENT_FAILURE,
  UPLOAD_ATTACHMENT_PROGRESS,
  UPDATE_ATTACHMENT,
  REMOVE_ATTACHMENT
} from 'actions/attachments'

const remove = (key, from) => {
  let result = { ...from }
  delete result[key]
  return result
}

const toAssociativeArray = array =>
  array.reduce((result, entry, idx) => {
    // deliberately uses a different id scheme than the attachment actions
    // to avoid conflicts or more complex mechanisms to share the id generator
    result[entry.uuid] = {
      result: entry
    }
    return result
  }, {})

const attachments = (state = {}, action = {}) => {
  const p = action.payload
  switch (action.type) {
    case INITIALISE_ATTACHMENTS:
      if (Array.isArray(action.payload.opts)) {
        state = toAssociativeArray(action.payload.opts)
      } else {
        state = action.payload.opts || {}
      }
      break
    case UPLOAD_ATTACHMENT_REQUEST:
      state = {
        ...state,
        [p.opts._upload_id]: {
          file: p.opts.file,
          progress: 0
        }
      }
      break
    case UPLOAD_ATTACHMENT_SUCCESS:
      state = {
        ...state,
        [p.opts._upload_id]: {
          file: p.opts.file,
          result: p.result[0]
        }
      }
      break
    case UPLOAD_ATTACHMENT_FAILURE:
      state = {
        ...state,
        [p.opts._upload_id]: {
          file: p.opts.file,
          error: p.error
        }
      }
      break
    case UPLOAD_ATTACHMENT_PROGRESS:
      state = {
        ...state,
        [p.opts._upload_id]: {
          file: p.opts.file,
          progress: p.progress
        }
      }
      break
    case UPDATE_ATTACHMENT:
      state = {
        ...state,
        [p.opts._upload_id]: {
          ...state[p.opts._upload_id],
          ...p.opts
        }
      }
      break
    case REMOVE_ATTACHMENT:
      state = remove(p.opts._upload_id, state)
      break
  }
  return state
}

export default attachments
